export const DEFAULT_ENV = 'DEV'
export const DEV_WEB_URL = import.meta.env.VITE_DEV_WEB_URL
export const TEST_WEB_URL = import.meta.env.VITE_TEST_WEB_URL
export const STAGING_WEB_URL = import.meta.env.VITE_STAGING_WEB_URL
export const PROD_WEB_URL = import.meta.env.VITE_PROD_WEB_URL

export type Environment = 'DEV' | 'TEST' | 'UAT' | 'PRODUCTION'

export const ENVIRONMENTS: readonly Environment[] = ['DEV', 'TEST', 'UAT', 'PRODUCTION']

export const resolveEnvironment = (value: string | undefined): Environment => {
  const normalized = (value ?? '').trim().toUpperCase() as Environment

  return ENVIRONMENTS.includes(normalized) ? normalized : DEFAULT_ENV
}

export const CURRENT_ENV = resolveEnvironment(import.meta.env.VITE_CURRENT_ENV)

export const ENVIRONMENT_URLS: Record<Environment, string> = {
  DEV: DEV_WEB_URL as string,
  TEST: TEST_WEB_URL as string,
  UAT: STAGING_WEB_URL as string,
  PRODUCTION: PROD_WEB_URL as string,
}

export const ENVIRONMENT_CHANGE_ALLOWED_ROLES = ['IAM', 'IQM', 'IQS', 'IPM']
